import store from '@/store'

export function handleSecureUploadRedirect(to) {
  const isSecureUploadLogin = store.state.globalComponents.isSecureUploadLogin
  const otpKey = store.state.globalComponents.otp_key
  const secureMemberData = store.state.globalComponents.secureMemberData
  const token = store.state.auth.token
  const memberId = to.params.id

  // Only handle secure upload login
  if (!isSecureUploadLogin || to.name === 'logout') return null

   // 2️⃣ If token + member data exist → go to details
  if (secureMemberData && token && to.name !== 'secure-upload-medicare-details') {
    return { name: 'secure-upload-medicare-details', params: { id: memberId } }
  }
  
  // 1️⃣ OTP required? Redirect to OTP page first
  if (otpKey && to.name !== 'secure-upload-otp') {
    return { name: 'secure-upload-otp', params: { id: memberId } }
  }

 

  // 3️⃣ Already on correct page or no redirect needed
  return null
}
